import isMergedCell from 'notebook/structured-tables/util/isMergedCell';

import {Cells, Row} from '../TableConstants';

/**
 * Transpose the given table (rows and columns are swapped)
 *
 * @param table - input array must be comprised of arrays of homogeneous length.
 */
export default function transpose(table: Cells): Cells {
  if (table.length === 0) {
    return [];
  }
  const newTable: Cells = [];
  for (let j = 0; j < table[0].length; j++) {
    const row: Row = [];
    for (let i = 0; i < table.length; i++) {
      const cell = table[i][j];
      // Swap the dimensions of a merged cell
      if (isMergedCell(cell)) {
        const mergeColSpan = cell.mergeColSpan ?? 1;
        const mergeRowSpan = cell.mergeRowSpan ?? 1;
        cell.mergeColSpan = mergeRowSpan;
        cell.mergeRowSpan = mergeColSpan;
      }
      row.push(table[i][j]);
    }
    newTable.push(row);
  }
  return newTable;
}
